<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p class="pTitle">实名认证</p>
                            <div v-if="status === 0">
                                <p>
                                    <img src="../../assets/images/center/reviewing.png" alt=""
                                         style="position: relative;top: 18px;">
                                    <span style="color: #5aa5ec;">审核中</span>
                                </p>
                                <p style="margin-top: 40px;">您的实名信息已成功提交！</p>
                                <p style="font-size: 14px;color: #999999;">
                                    我们会在5个工作日（不包含节假日）内完成审核，审核结果将会以短信和系统通知的形式发送给您。</p>
                            </div>
                            <div v-if="status === 1" style="margin-top: 3em;">
                                <div><span style="position: relative;"><i class="el-icon-circle-check"
                                                                          style="color: #5cb138;font-size: 2em;position: absolute;top:-0.2em;"></i></span><span
                                    style="margin-left: 2.5em">您的账户已通过认证</span>
                                </div>
                                <el-form style="margin-top: 1em;" label-position="right" label-width="100px">
                                    <el-form-item label="姓名：" style="margin-bottom: 0;">{{ realName }}</el-form-item>
                                    <el-form-item label="身份证号：" v-if="idCard.length > 0">{{ idCard }}</el-form-item>
                                </el-form>
                            </div>
                            <div v-if="status === -1">
                                <p>
                                    <img src="../../assets/images/center/review_fail.png" alt=""
                                         style="position: relative;top: 18px;">
                                    <span style="color: #f56c6c;">审核未通过</span>
                                </p>
                                <p style="margin-top: 40px;">理由：{{ reason }}
                                </p>
                                <p style="font-size: 14px;color: #999999;width: 650px;">
                                    如果您填写信息有误，或者上传的照片没有达到标准，您可以重新修改作日（不包含节假日）内完成审核，审核结果将会以短信和系统通知的形式发送给您。</p>
                                <div style="margin-top: 3em;">
                                    <el-button type="primary" @click="toEdit">修改认证信息</el-button>
                                </div>
                            </div>
                            <el-form style="margin-top: 120px;">
                                <el-form-item>
                                    <div class="div-notice">
                                        <p style="font-weight: bolder;color: #333333;margin-bottom: 10px;">认证须知</p>
                                        <p>1、实名认证可以提升你在恒点MOOL的个人信息及虚拟财产的安全等级，同时也能够更好的体验恒点的各项虚拟服务；</p>
                                        <p>2、我们将在你提交身份证信息后的5个工作日（不包含节假日）内完成审核，审核结果将会以短信和系统通知的形式发送给你；</p>
                                        <p>3、如若账号还未绑定手机，建议你提前绑定手机；</p>
                                        <p>4、实名认证审核完成后，将无法修改和删除，请谨慎填写；</p>
                                        <p>5、你需要准备身份证照片（需正反两面），请确保证件照片清晰可见，严禁PS，具体可参考实名认证常见问题；</p>
                                        <p>6、我们会确保你所提供的信息均处于严格的保密状态，不会泄露；</p>
                                        <p>7、如存在恶意乱填写姓名，身份证号码，及上传与身份证证件无关图片者，一经发现将冻结恒点账号。</p>
                                    </div>
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'

export default {
    name: 'UserRealnameSuccess',
    components: {
        HdHeader,
        HdFooter,
        HdAside
    },
    created () {
        this.getDefaultValue()
    },
    data () {
        return {
            realName: '',
            idCard: '',
            status: 0,
            reason: '因您不是在校老师/学生，所有没有权限申请此权利'
        }
    },
    methods: {
        getDefaultValue () {
            let that = this
            //先判断是否已经实名
            this.$ajax.get('/api/user/get').then(function (r) {
                if (r.data.real_is_checked === 1) {
                    //赋值
                    that.realName = r.data.real_name
                    that.idCard = r.data.id_number
                    that.status = r.data.real_is_checked
                } else {
                    that.$ajax.get('/api/userauth/getbyuserid').then(function (res) {
                        if (that.isEmpty(res.data)) {
                            //进入编辑
                            that.toEdit()
                            return
                        }
                        //赋值
                        that.realName = res.data.real_name
                        that.idCard = res.data.id_number
                        that.status = res.data.status
                        that.reason = res.data.reason
                    })
                }
            })
        },
        toEdit () {
            this.$router.push({
                path: '/user-realname'
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.div-notice {
    background-color: #f5f6fa;
    border-radius: 5px;
    padding: 20px;
}

.div-notice p {
    padding: 0;
    margin: 0;
    line-height: 25px;
    color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserRealnameResult.vue